module.exports = __webpack_public_path__ + "static/media/uk.783fa34a.jpg";